import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/fr'

dayjs.extend(utc)

export const FORMAT_DDMMYYYY = 'DD/MM/YYYY'
export const FORMAT_MMDDYYYY = 'MM/DD/YYYY'
export const FORMAT_YYYYMMDD = 'YYYY-MM-DD'
export const FORMAT_DDMMYYYY_VALIDATION_REGEXP = new RegExp(/^(31\/(0[13578]|10|12)|30\/(0[13-9]|1[0-2])|(0[1-9]|[12][0-9])\/(0[1-9]|1[0-2]))\/([0-9]{4})$/)

export function formatDate(date: string | Date): string {
  return dayjs(date).format('DD/MM/YYYY HH:mm')
}

export function formatDateDMY(date: string): string {
  return dayjs(date).format(FORMAT_DDMMYYYY)
}

export function formatDateUS(date: string): string {
  return dayjs(date).format(FORMAT_MMDDYYYY)
}

export function formatBirthday(birthday: string, isUS = false) {
  if (!birthday) return ''
  return dayjs.utc(birthday).format(isUS ? 'MM/DD/YYYY' : 'DD/MM/YYYY')
}

export function isValidDate(date: string, format = FORMAT_YYYYMMDD): boolean {
  return dayjs(date, format, true).isValid()
}

/**
 * Rebuilds a date-only value (e.g. birthday) as UTC midnight of its local calendar day, instead of
 * reinterpreting the local instant as UTC. Converting a local instant directly (e.g. `dayjs.utc(date)`)
 * shifts the day back for positive UTC offsets (e.g. France), since local midnight is still the previous
 * day in UTC. Accepts a Date, Dayjs, or nullish value; returns null for nullish input.
 */
export function toUtcMidnight(date: Date | Dayjs | null | undefined): Dayjs | null {
  if (!date) return null
  const local = dayjs(date)
  return dayjs.utc().year(local.year()).month(local.month()).date(local.date()).startOf('day')
}
